import { z } from 'zod';

export const clientAreaPostFileSchema = z.object({
  id: z.string(),
  name: z.string(),
  url: z.string(),
  type: z.string(),
});

export const clientAreaPostAttachmentSchema = z.object({
  id: z.string(),
  file: clientAreaPostFileSchema,
});

export const clientAreaPostPlatformSchema = z.object({
  id: z.string(),
  platform: z.string(),
  content: z.string().nullable(),
  clientPlatformAccountId: z.string().nullable(),
  accountDisplayName: z.string().nullable(),
  accountProfilePictureUrl: z.string().nullable(),
  attachmentIds: z.array(z.string()),
  suggestedContent: z.string().nullable(),
  suggestedContentCreatedAt: z.coerce.date().nullable(),
});

export const clientAreaReviewStateSchema = z.enum([
  'awaiting_review',
  'changes_requested',
  'approved',
  'scheduled',
  'published',
]);

export const clientAreaPostSchema = z.object({
  id: z.string(),
  title: z.string(),
  date: z.coerce.date().nullable(),
  publishedAt: z.coerce.date().nullable(),
  approvedAt: z.coerce.date().nullable(),
  changesRequestedAt: z.coerce.date().nullable(),
  reviewState: clientAreaReviewStateSchema,
  platforms: z.array(clientAreaPostPlatformSchema),
  attachments: z.array(clientAreaPostAttachmentSchema),
});

export const clientAreaPostsResponseSchema = z.object({
  posts: z.array(clientAreaPostSchema),
});

export const clientAreaPostActionResponseSchema = z.object({
  post: clientAreaPostSchema,
});

export type ClientAreaPostFileSchema = z.infer<typeof clientAreaPostFileSchema>;
export type ClientAreaPostAttachmentSchema = z.infer<typeof clientAreaPostAttachmentSchema>;
export type ClientAreaPostPlatformSchema = z.infer<typeof clientAreaPostPlatformSchema>;
export type ClientAreaReviewStateSchema = z.infer<typeof clientAreaReviewStateSchema>;
export type ClientAreaPostSchema = z.infer<typeof clientAreaPostSchema>;
export type ClientAreaPostsResponseSchema = z.infer<typeof clientAreaPostsResponseSchema>;
export type ClientAreaPostActionResponseSchema = z.infer<typeof clientAreaPostActionResponseSchema>;
